// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoConnection_wrapper__269iB","innerWrapper":"NoConnection_innerWrapper__3iQyJ","subtitle":"NoConnection_subtitle__3uiZp","text":"NoConnection_text__22A8T"};